var _TYPES_COMPONENT_MAP;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import { Link } from 'react-router';
import classNames from 'classnames';
import { ANCHOR_LINK, ROUTER_LINK, EXPAND_LINK, DIVIDER, SECTION_HEADER, TYPE_PROP_TYPE } from './constants';
import ListItem from '../listItem/ListItem';
import BaseLink from './_internal/BaseLink';
import { ICON_TYPE_PROP_TYPE, ICON_SIZE_PROP_TYPE, COLOR_PROP_TYPE } from '../icon/constants';
import Button from '../button/Button';
import Divider from '../divider/Divider';
import { VERTICAL_ALIGNMENTS_PROP_TYPE } from '../listItem/constants';

var AnchorLink = function AnchorLink(_ref) {
  var path = _ref.path,
      isTentativelySelected = _ref.isTentativelySelected,
      anchorProps = _objectWithoutProperties(_ref, ["path", "isTentativelySelected"]);

  return React.createElement(BaseLink, _extends({}, anchorProps, {
    LinkComponent: "a",
    href: path,
    "data-spec": "anchor-list-item",
    isTentativelySelected: isTentativelySelected
  }));
};

var RouterLink = function RouterLink(_ref2) {
  var path = _ref2.path,
      anchorProps = _objectWithoutProperties(_ref2, ["path"]);

  return React.createElement(BaseLink, _extends({}, anchorProps, {
    LinkComponent: Link,
    to: path
  }));
};

var ExpandLink = function ExpandLink(_ref3) {
  var onActivate = _ref3.onActivate,
      children = _ref3.children,
      iconType = _ref3.iconType,
      active = _ref3.active,
      useAltTheme = _ref3.useAltTheme,
      isDisabled = _ref3.isDisabled,
      extraProps = _objectWithoutProperties(_ref3, ["onActivate", "children", "iconType", "active", "useAltTheme", "isDisabled"]);

  var buttonProps = _.omit(extraProps, 'path', 'isTentativelySelected');

  var className = classNames('eds-nav-list-item', 'eds-nav-list-item--link', {
    'eds-nav-list-item--active': active,
    'eds-nav-list-item--alt-theme': useAltTheme,
    'eds-nav-list-item--disabled': isDisabled
  });
  return React.createElement(Button, _extends({}, buttonProps, {
    __containerClassName: className,
    style: "anchor",
    disabled: isDisabled,
    onClick: onActivate,
    "data-spec": "expand-list-item"
  }), React.createElement(ListItem, {
    iconType: iconType,
    isSelected: active,
    useAltTheme: useAltTheme
  }, children));
};

var NavDivider = function NavDivider() {
  return React.createElement("div", {
    className: "eds-nav-list-item--divider"
  }, React.createElement(Divider, {
    color: "grey-200"
  }));
};

var SectionHeader = function SectionHeader(_ref4) {
  var children = _ref4.children;
  return React.createElement("div", {
    className: "eds-nav-list-item--section-header eds-l-pad-vert-4 eds-l-pad-left-2"
  }, React.createElement("h4", {
    className: "eds-text-color--ui-800"
  }, children));
};

var TYPES_COMPONENT_MAP = (_TYPES_COMPONENT_MAP = {}, _defineProperty(_TYPES_COMPONENT_MAP, ROUTER_LINK, RouterLink), _defineProperty(_TYPES_COMPONENT_MAP, ANCHOR_LINK, AnchorLink), _defineProperty(_TYPES_COMPONENT_MAP, DIVIDER, NavDivider), _defineProperty(_TYPES_COMPONENT_MAP, EXPAND_LINK, ExpandLink), _defineProperty(_TYPES_COMPONENT_MAP, SECTION_HEADER, SectionHeader), _TYPES_COMPONENT_MAP);

var NavListItem =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(NavListItem, _React$PureComponent);

  function NavListItem() {
    _classCallCheck(this, NavListItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(NavListItem).apply(this, arguments));
  }

  _createClass(NavListItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          componentAttrs = _objectWithoutProperties(_this$props, ["type"]);

      var NavListItemSubComponent = TYPES_COMPONENT_MAP[type];
      return React.createElement(NavListItemSubComponent, componentAttrs);
    }
  }]);

  return NavListItem;
}(React.PureComponent);

_defineProperty(NavListItem, "propTypes", {
  /**
   * The type of the nav list item
   */
  type: TYPE_PROP_TYPE.isRequired,

  /**
   * The contents of the nav list item
   */
  children: PropTypes.node,

  /**
   * The URL path to navigate to
   */
  path: PropTypes.string,

  /**
   * Whether or not the nav list item is active
   */
  active: PropTypes.bool,

  /**
   * The icon type to include in the nav list item
   */
  iconType: ICON_TYPE_PROP_TYPE,

  /**
   * Size of included icon
   */
  iconSize: ICON_SIZE_PROP_TYPE,

  /**
   * Color of included icon
   */
  iconColor: COLOR_PROP_TYPE,

  /**
   * Color of included stroke
   */
  iconStrokeColor: COLOR_PROP_TYPE,

  /**
   * URL of image to be displayed with list item content
   */
  imageUrl: PropTypes.string,

  /**
   * Alt text for image to be displayed with list item content
   */
  imageAlt: EBPropTypes.translation,

  /**
   * Optional square shape image - note you must pass in an imageUrl
   * for an image that is either 1:1 or wider than it is tall.
   */
  isSquareImage: PropTypes.bool,

  /**
   * Vertical alignment of children items
   */
  verticalAlignment: VERTICAL_ALIGNMENTS_PROP_TYPE,

  /*
  * Sets active link state
  */
  onActivate: PropTypes.func,

  /**
   * Whether or not the item should use an alternate theme
   */
  useAltTheme: PropTypes.bool,

  /**
   * Whether or not the item is disabled
   */
  isDisabled: PropTypes.bool,

  /**
   * Whether or not the nav list item is tenatively selected.
   * This comes into play on hover or via arrow key press before an
   * actual selection is made
   */
  isTentativelySelected: PropTypes.bool
});

_defineProperty(NavListItem, "defaultProps", {
  active: false,
  useAltTheme: false,
  isDisabled: false
});

export { NavListItem as default };